export default __webpack_public_path__ + "static/media/044-mole.bb1184df.svg";